interface BadgeProps {
	text: string;
	signal?: string;
	visible?: boolean;
	cssClasses?: string;
}

const getSignalClasses = (signal: string) => {
	switch (signal) {
		case 'success':
			return 'bg-green-500 text-white';
		case 'danger':
			return 'bg-red-500 text-white';
		case 'warning':
			return 'bg-yellow-500 text-black';
		case 'info':
			return 'bg-blue-500 text-white';
		case 'primary':
			return 'bg-primary text-primary-foreground';
		case 'secondary':
			return 'bg-muted text-foreground';
		default:
			return 'bg-gray-500 text-white';
	}
};

const Badge = ({ text, signal = 'success', visible = false, cssClasses = '' }: BadgeProps) => {
	if (!visible) return null;

	return (
		<div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
			<span
				className={`inline-block rounded-full text-sm font-normal px-3 py-0.5 whitespace-nowrap ${getSignalClasses(signal)} ${cssClasses}`}
				data-testid={`badge-${signal}`}
			>
				{text}
			</span>
		</div>
	);
};

export default Badge;
